
import {tns} from '../../node_modules/tiny-slider';

//projects-showcase
const projectsShowcases = document.querySelectorAll('div.projects-showcase')
projectsShowcases.forEach(projectShowcase =>{
    const sliderEl = projectShowcase.querySelector('.my-slider')
    const sliderControlsEl = projectShowcase.querySelector('.slider-arrows')
    if (sliderEl && sliderControlsEl) {
        var slider = tns({
            container: sliderEl, 
            controlsContainer: sliderControlsEl,
            items: 1, 
            autoplay: false,
            nav: false,
            speed: 700,
            gutter: 48,
            responsive: {
                767: {
                    items: 2
                }
            }
        });
    }

})

//projects-slider
const projectsSliders = document.querySelectorAll('section.projects-slider-container')
projectsSliders.forEach(projectslider =>{
    const sliderEl = projectslider.querySelector('.project-slider')
    const sliderControlsEl = projectslider.querySelector('.project-slider-arrows')
    if (sliderEl && sliderControlsEl) {
        var slider = tns({
            container: sliderEl, 
            controlsContainer: sliderControlsEl,
            items: 1, 
            slideBy: 1, 
            autoplay: false,
            nav: false,
            speed: 700,
            gutter: 48,
            loop: true,
            responsive: {
                767: {
                    items: 2
                },
                1200: {
                    items: 3
                }
            }
        });
    }
})


//testimonial-slider
const testimonialSliders = document.querySelectorAll('section.testimonial-slider-container')
testimonialSliders.forEach(testimonialSlider =>{
    const sliderEl = testimonialSlider.querySelector('.testimonial-slider')
    const sliderControlsEl = testimonialSlider.querySelector('.testimonial-slider-arrows')
    if (sliderEl && sliderControlsEl) {
        var slider = tns({
            container: sliderEl, 
            controlsContainer: sliderControlsEl,
            items: 1, 
            slideBy: 'page', 
            autoplay: false,
            nav: false,
            speed: 700,
            gutter: 40,
        });
    }
})